import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { AppGlobals } from '../app.global';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  static urlport: any;
  messages: string[] = [];
  constructor(public http: HttpClient,private appGlobals:AppGlobals) {

   }

   validateADLogin(username:any,pwd:any) {

var url=this.appGlobals.baseAPIUrl + 'api/validateLogin/AuthenticateUser/';
     let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //  headers.append('Accept', 'application/json');
    //  headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
    //  headers.append('Access-Control-Allow-Origin', 'localhost:4200');
    //  headers.append('Access-Control-Allow-Headers', "X-Requested-With, Content-Type, Origin, Authorization, Accept, Client-Security-Token, Accept-Encoding");
    return this.http.post(url,
    {
        "userID": username,
        "pwd": pwd
    },{headers});
    // .subscribe(
    //     data => {
    //         console.log("POST Request is successful ", data);
    //         if(data!=null)
    //         {
    //           sessionStorage.setItem("LoginSession", data.toString());
    //           sessionStorage.setItem("UserName", username.toString());
    //         }
            
    //         //return data;
    //     },
    //     error => {
    //         console.log("Error", error);
    //     }
    // );


   }


}
